<template>
  <!-- note: vue2 requires only one root element so wrap in a div-->
  <div>
    <template v-if="emailProcessStep === 'enterEmail'">
      <h1>{{ my18n('Header') }}</h1>
      <p>{{ my18n('AuthenticationInfo') }}</p>
      <label> {{ my18n('EnterUserIdentifier') }} <input :type="inputType" v-model="userIdentifier" /> </label>
      <br />
      <br />
      <button class="primary" @click="sendCode_click()">{{ my18n('SendCode') }} </button>
    </template>
    <template v-else-if="emailProcessStep === 'enterCode'">
      <label>{{ my18n('EnterCode') }} <input name="Code" v-model="emailCode" /> </label>

      <br />
      <br />
      <button class="primary" @click="validateCode_click()">{{ my18n('SubmitCode') }}</button>
    </template>

    <p v-if="emailErrorMessage">{{ my18n(emailErrorMessage) }}</p>
  </div>
</template>
<script lang="ts" setup>

import { ref, computed, type PropType} from 'vue';
import { useI18n } from '../i18n-shim';

import { EOtpLoginClient, SendEmailResultCode, CodeValidationResult, OtpType, SignatureRequestType } from './esignclient';

const inputType= computed(()=> {
  return props.otpType === 'sms' ? 'tel' : 'email';
});
const props = defineProps(
  {
    tenantId: {
      type: String,
      required: true
    },

    signFlowId: {
      type: String,
      required: true,
    },
    signatureRequestType: {
      type: String as PropType<SignatureRequestType>,
      required: true,
    },
    signatureId: {
      type: String,
      required: true,
    },
    otpType: {
      type: String,
      required: true,
      validator: (value: string) => {
        return value === 'email' || value === 'sms';
      }
    },
    authenticationSchemeId : {
      type: String,
      required: false,
    }
  }
)
const i18n = useI18n();
const userIdentifier = ref('');
const emailCode = ref('');
const emailProcessStep = ref<'enterEmail' | 'enterCode'>('enterEmail');
const emailErrorMessage = ref('');

const otpClient = new EOtpLoginClient();
const otpTypeTyped = props.otpType === 'sms' ? OtpType.Sms : OtpType.Email;

function my18n(key: string) {
  return i18n.t('Otp_'+otpTypeTyped+'_'+key);
}
async function sendCode_click() {
  if(userIdentifier.value === '') {
    emailErrorMessage.value = 'UserIdentifierInvalid';
    return;
  }
  const result = await otpClient.send(otpTypeTyped, props.authenticationSchemeId, props.tenantId, props.signFlowId, props.signatureId, props.signatureRequestType, userIdentifier.value);
  switch (result) {
    case SendEmailResultCode.Ok:
    case SendEmailResultCode.CannotRetryTooSoon:
      emailErrorMessage.value = 'CannotSendCodeTooSoon';
      emailProcessStep.value = 'enterCode';
      break;
    case SendEmailResultCode.InvalidSignatureIdOrEmail:
      emailErrorMessage.value = 'UserIdentifierInvalid';
      break;
    default:
      throw new Error('Unexpected result code ' + result);
  }
}
async function validateCode_click() {
  if(emailCode.value === '') {
    emailErrorMessage.value = 'CodeInvalid';
    return;
  }
  const result = await otpClient.validateCode(otpTypeTyped, props.authenticationSchemeId, props.tenantId, props.signFlowId, props.signatureId, props.signatureRequestType, emailCode.value);
  switch (result.result) {
    case CodeValidationResult.Ok:
      window.location.href = result.redirectUrl;
      break;
    case CodeValidationResult.InvalidCode:
      emailErrorMessage.value = 'CodeInvalid';
      break;
  }
}
</script>